export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_SCHOOL_INFO = 'SET_SCHOOL_INFO';
export const SET_TRIAL_PERIOD_INFO = 'SET_TRIAL_PERIOD_INFO';
export const SET_USER_LOGO_REQUEST = 'SET_USER_LOGO_REQUEST';
export const SET_USER_LOGO_SUCCESS = 'SET_USER_LOGO_SUCCESS';
export const SET_USER_LOGO_FAILED = 'SET_USER_LOGO_FAILED';
export const SET_PARENT_PORTAL_URL = 'SET_PARENT_PORTAL_URL';
export const SET_SCHOOL_LOGO_REQUEST = 'SET_SCHOOL_LOGO_REQUEST';
export const SET_SCHOOL_LOGO_SUCCESS = 'SET_SCHOOL_LOGO_SUCCESS';
export const SET_SCHOOL_LOGO_FAILED = 'SET_SCHOOL_LOGO_FAILED';


// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js